import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  selectedCategory: any = null;
  public selectedCategoryChange: Subject<any> = new Subject<any>();
  categoriesUrl = environment.API_URL+"/Category";

  constructor(private http : HttpClient) { }

  getAll(): any {
    return this.http.get(this.categoriesUrl);
  }
  setSelected(cat: any): void{
    this.selectedCategory = cat;
    this.selectedCategoryChange.next(cat);
  }
}
